import React from 'react';
import { ProductCard } from './ProductCard';

/**
 * Оптимизированная плоская сетка каталога FEDYK Furniture.
 * Защищена от сдвигов макета при подгрузке тяжелых компонентов.
 */
export const ProductGrid = ({ 
  products, 
  language, 
  categoryLabels, 
  ctaLabel, 
  isAuthenticated, 
  isInWishlist, 
  onWishlistToggle 
}) => {
  if (!products?.length) return null;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-20 md:gap-x-16 md:gap-y-28">
      {products.map((product, index) => (
        <ProductCard
          key={product.id}
          product={product}
          index={index}
          language={language}
          categoryLabel={categoryLabels[product.category] || product.category}
          ctaLabel={ctaLabel}
          isAuthenticated={isAuthenticated}
          isInWishlist={isInWishlist}
          onWishlistToggle={onWishlistToggle}
        />
      ))}
    </div>
  );
};

/**
 * Сгруппированная по коллекциям сетка с защитой от накопительного сдвига (CLS).
 */
export const CollectionGroupedGrid = ({
  groups,
  orderedKeys,
  categoryLabels,
  eyebrowLabel,
  viewAllLabel,
  language,
  ctaLabel,
  isAuthenticated,
  isInWishlist,
  onWishlistToggle,
  onViewCategory,
}) => (
  <div className="space-y-24 md:space-y-32">
    {orderedKeys.map((catId) => (
      <section key={catId} data-testid={`collection-group-${catId}`} className="scroll-mt-28">
        <div className="flex items-end justify-between mb-12 md:mb-16 border-b border-border pb-6">
          <div>
            <p className="text-caption text-muted-foreground mb-2">{eyebrowLabel}</p>
            <h2 className="text-h2 font-extralight">{categoryLabels[catId] || catId}</h2>
          </div>
          <button
            type="button"
            onClick={() => onViewCategory(catId)}
            className="hidden md:inline-flex text-xs tracking-[0.25em] uppercase font-light text-muted-foreground hover:text-foreground transition-colors border-b border-border hover:border-foreground pb-1"
            data-testid={`view-collection-${catId}`}
          >
            {viewAllLabel}
          </button>
        </div>

        <ProductGrid
          products={groups[catId]}
          language={language}
          categoryLabels={categoryLabels}
          ctaLabel={ctaLabel}
          isAuthenticated={isAuthenticated}
          isInWishlist={isInWishlist}
          onWishlistToggle={onWishlistToggle}
        />
      </section>
    ))}
  </div>
);

export default ProductGrid;
